// ============= Imports =============
import React from 'react';
import { FiPlus } from 'react-icons/fi';
import { CREATE_PROMPT_MESSAGES } from '@/constants/visualPrompts/createPromptMessages';
import {
  CreateCardButton,
  Description,
  IconWrap,
  TextWrap,
  Title,
} from './styles';

export interface CreateVisualPromptCardProps {
  onClick: () => void;
  disabled?: boolean;
  variant?: 'compact' | 'default';
}

// ============= Component =============
export const CreateVisualPromptCard: React.FC<CreateVisualPromptCardProps> = ({
  onClick,
  disabled = false,
}) => (
  <CreateCardButton
    type="button"
    disabled={disabled}
    $disabled={disabled}
    onClick={() => !disabled && onClick()}
  >
    <IconWrap aria-hidden>
      <FiPlus />
    </IconWrap>
    <TextWrap>
      <Title>{CREATE_PROMPT_MESSAGES.cardTitle}</Title>
      <Description>{CREATE_PROMPT_MESSAGES.cardDescription}</Description>
    </TextWrap>
  </CreateCardButton>
);
